import React from "react";

import clsx from "clsx";
import Image from "next/image";

import FigureImage from "public/images/enerflo-solar-customer-portal.png";

import HeroSection from "../../hero-section";
import styles from "./index.module.css";
import TimelineContent from "./timeline-content";

const title = "Customer Portal";

const CustomerPortal = () => (
  <div className={clsx("timeline-section-wrapper", styles.timelineSectionWrapper)}>
    <HeroSection title={title} className={styles.timelineSection}>
      <div className={styles.timelineSectionGrid}>
        <figure className={clsx(styles.timelineFigure)}>
          <div className="mx-auto w-2/3 xs:w-2/5 md:w-[125%] md:ml-[10%]">
            <Image
              src={FigureImage}
              alt="The Enerflo Solar Customer Portal keeps customers informed from sales through installation and allows them to upload bills, documents, chat, see important updates and notes, submit referrals and more."
              layout="responsive"
              quality={100}
              placeholder="blur"
              className="crispImage"
              sizes="(min-width: 768px) 50vw, 100vw"
              lazyBoundary="400px"
            />
          </div>
        </figure>
        <TimelineContent
          title={title}
          description="Enerflo’s Customer Portal makes it easy for you to keep your customers informed along the entire project journey, increasing your conversion and pull-through rates. Your customers can upload bills, reference documents, chat, contact their project managers, see important updates and notes, submit referrals and more."
          offsetFigure
          icon={
            <Image
              src="/images/icons/customer-portal.svg"
              alt="Icon - Enerflo Customer Portal"
              layout="responsive"
              height={69}
              width={43}
              quality={100}
              className="crispImage"
            />
          }
          link="/features/customer-engagement"
        />
      </div>
    </HeroSection>
  </div>
);

export default CustomerPortal;
